<a *ngIf="text" class="a-link {{ modifier && 'a-link--' + modifier || ''}} {{ class }}"
   (click)="handleClick($event)"
   [href]="href || ''"
   [title]="title || ''"
   [target]="target || ''"
   data-t-name="Link"
   [attr.data-t-decorator]="decorator">
   <span [innerHTML]="text"></span>
</a>
